/** Client defaults when API unavailable (match PHP ship_from_locations_defaults). */
export const SHIP_FROM_DEFAULTS = {
  default_id: 'ahmedabad',
  label_size: 'thermal_4x6',
  locations: [
    {
      id: 'ahmedabad',
      label: 'Ahmedabad',
      name: 'Saloni Designs',
      address_line1: '',
      address_line2: '',
      city: 'Ahmedabad',
      state: 'Gujarat',
      pincode: '',
      phone: '',
      is_default: true,
    },
    {
      id: 'pune',
      label: 'Pune',
      name: 'Saloni Designs',
      address_line1: '',
      address_line2: '',
      city: 'Pune',
      state: 'Maharashtra',
      pincode: '',
      phone: '',
      is_default: false,
    },
  ],
};

export function mergeShipFromConfig(raw) {
  const base = JSON.parse(JSON.stringify(SHIP_FROM_DEFAULTS));
  if (!raw || typeof raw !== 'object') return base;
  const size = String(raw.label_size || base.label_size).toLowerCase();
  base.label_size = size === 'standard' ? 'standard' : 'thermal_4x6';
  base.default_id = String(raw.default_id || base.default_id);
  if (Array.isArray(raw.locations) && raw.locations.length) {
    base.locations = raw.locations.map((loc, i) => ({
      id: String(loc.id || `loc-${i}`),
      label: String(loc.label || ''),
      name: String(loc.name || 'Saloni Designs'),
      address_line1: String(loc.address_line1 || ''),
      address_line2: String(loc.address_line2 || ''),
      city: String(loc.city || ''),
      state: String(loc.state || ''),
      pincode: String(loc.pincode || '').replace(/\D/g, '').slice(0, 6),
      phone: String(loc.phone || ''),
      is_default: Boolean(loc.is_default),
    }));
  }
  return base;
}

export function locationToSender(loc) {
  const lines = [];
  ['address_line1', 'address_line2'].forEach((k) => {
    const v = String(loc[k] || '').trim();
    if (v) lines.push(v);
  });
  const city = String(loc.city || '').trim();
  const state = String(loc.state || '').trim();
  const pin = String(loc.pincode || '').trim();
  const cityState = [city, state].filter(Boolean).join(', ');
  if (cityState) {
    lines.push(pin ? `${cityState} — ${pin}` : cityState);
  } else if (pin) {
    lines.push(`PIN ${pin}`);
  }
  if (!lines.length) {
    lines.push(loc.label ? `${loc.label}, India` : 'India');
  }
  return {
    id: loc.id,
    label: loc.label,
    name: String(loc.name || '').trim() || 'Saloni Designs',
    lines,
    phone: String(loc.phone || '').trim(),
  };
}

export function configToPrintOptions(config) {
  const cfg = mergeShipFromConfig(config);
  return cfg.locations
    .filter((loc) => loc.label)
    .map((loc) => ({
      id: loc.id,
      label: loc.label,
      is_default: loc.id === cfg.default_id || loc.is_default,
      sender: locationToSender(loc),
    }));
}

export function defaultShipFromId(config, printOptions) {
  const opts = printOptions?.length ? printOptions : configToPrintOptions(config);
  const def = opts.find((o) => o.is_default) || opts[0];
  return def?.id || 'ahmedabad';
}

export function senderForId(printOptions, id) {
  const opt = (printOptions || []).find((o) => o.id === id);
  return opt?.sender || (printOptions?.[0]?.sender ?? locationToSender(SHIP_FROM_DEFAULTS.locations[0]));
}

/**
 * Inline width for ship-from select wrapper (ch units ≈ character count).
 *
 * @param {Array<{ label?: string, id?: string }>} options
 * @returns {{ width: string, minWidth: string }}
 */
export function shipFromSelectWidthStyle(options) {
  let maxLen = 5;
  for (const o of options || []) {
    const label = String(o.label ?? o.id ?? '').trim();
    maxLen = Math.max(maxLen, label.length);
  }
  const ch = maxLen + 6;
  return { width: `${ch}ch`, minWidth: `${ch}ch` };
}

export function newEmptyLocation() {
  return {
    id: '',
    label: '',
    name: 'Saloni Designs',
    address_line1: '',
    address_line2: '',
    city: '',
    state: '',
    pincode: '',
    phone: '',
    is_default: false,
  };
}
